import axiosInstance from './axiosInstance';

// Simple refund-request toggle (no approval / no clawback): an agent flags a sale
// as "refund requested" and can cancel it again. The action is also written to the
// sale's activity log (module "Sales") so it shows in Remarks & History.

// Returns the refund requests for a sale (most-recent first). The toggle treats a
// row with Status "Pending" as the active/open request.
export const getRefundBySale = (salesId) =>
    axiosInstance.get(`/RefundRequest/BySale?salesId=${salesId}`);

export const createRefundRequest = ({ salesId, reason, remarks }) =>
    axiosInstance.post('/RefundRequest/Create', { salesId, reason, remarks });

export const cancelRefundRequest = (refundRequestId) =>
    axiosInstance.post('/RefundRequest/Cancel', { refundRequestId });
